<template>
  <div class="result">
    
    <div v-if="isPassing" class="result__ok">
      <div class="result__ok-panel">
        <div class="result__ok-label">
          {{ title }}
        </div>
        <div class="result__ok-title">
          <img :src="`${staticPath}img/factory/test/result_ok.png`">
        </div>
        <div class="result__ok-button">
          <button v-on:click="gotoPresent">プレゼントを開ける</button>
        </div>
      </div>
    </div>

    <div v-else class="result__ng">
      <div class="result__ng-panel">
        <VuePerfectScrollbar class="scroll-area" v-bind:settings="settings" tagname="div" ref="ps">

          <div class="result__ng-title">
            <img :src="`${staticPath}img/factory/test/result_ng.png`">
          </div>
          <ul class="result__ng-items">
            <li class="result__ng-item--ok">
              <p class="label"><img :src="`${staticPath}img/factory/test/result_ng_ok_label.png`"></p>
              <p class="num">{{ numOK }}<small>問</small></p>
            </li>
            <li class="result__ng-item--ng">
              <p class="label"><img :src="`${staticPath}img/factory/test/result_ng_ng_label.png`"></p>
              <p class="num">{{ numNG }}<small>問</small></p>
            </li>
          </ul>

          <div class="result__ng-button-restart">
            <button v-on:click="gotoSelfMenu"><img :src="`${staticPath}img/factory/test/btn_test_restart.png`"></button>
          </div>
          <div class="result__ng-button-return">
            <button v-on:click="gotoFactory">工場に戻る</button>
          </div>

          <div class="comments">
            <div class="comments__inner">
              <div class="comment__title">
                <p>不正解問題の復習</p>
              </div>
              <ul class="comment__items">
                <li v-for="comment in comments" v-bind:key="comment.id" class="comment__item">
                  <div class="comment__item-no">
                    <p>{{ comment.id }} / {{ questionNum }}</p>
                  </div>
                  <div class="comment__item-q-text">
                    <p>{{ comment.questionText }}</p>
                  </div>
                  <div v-if="comment.questionImage" class="comment__item-note-img">
                    <img :src="`${staticPath}img/factory/test/question/${testType}_${testId}_${comment.id}.png`">
                  </div>
                  <div class="comment__item-answer">
                    答え…{{ comment.answer }}
                  </div>
                  <div class="comment__item-note-text">
                    <p>{{ comment.commentText }}</p>
                  </div>
                  <div v-if="comment.commentImage" class="comment__item-note-img">
                    <img :src="`${staticPath}img/factory/test/comment/${testType}_${testId}_${comment.id}.png`">
                  </div>
                </li>
              </ul>

              <div class="result__ng-button-restart">
              <button v-on:click="gotoSelfMenu"><img :src="`${staticPath}img/factory/test/btn_test_restart.png`"></button>
              </div>
              <div class="result__ng-button-return">
                <button v-on:click="gotoFactory">工場に戻る</button>
              </div>
            </div>
          </div>

        </VuePerfectScrollbar>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/test_result.scss';

  .scroll-area {
    height: 100%;
    padding-right: 20px;
  }
</style>

<style lang="scss">
  @import '@/assets/scss/_scrollbar.scss';
</style>

<script>
  import Constant from '@/constant';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';

  export default {
    name: 'Result',
    props: ['testType', 'testId', 'resultAnswer', 'title', 'questions'],

    components: {
      VuePerfectScrollbar
    },

    data(){
      return {
        staticPath: Constant.STATICPATH,
        settings: {
          suppressScrollX: true,
          swipeEasing: false
          //maxScrollbarLength: 300
        },
        isPassing: false,
        comments: [],  // 解説リスト,
        numOK: 0,
        numNG: 0,
      }
    },

    created() {
      
      const q_num = this.questions.length;

      let comments = [];

      for (let i = 0; i <= (q_num - 1); i++) {

        const res = this.resultAnswer[i];

        if (res) {
          // 正解
          this.numOK++;

        } else {
          // 不正解の場合解説リスト作成

          this.numNG++;
          
          const q = this.questions[i];

          let answer = '';

          if (q.answerType == 'yesno') {
            
            if (q.correctId == 1) {
              answer = '○';
            } else {
              answer = '×';
            }

          } else if (q.answerType == 'choice') {

            const c_id = q.correctId;

            if (c_id && !isNaN(c_id) && c_id > 0 && c_id <= q.choices.length) {
              answer = q.choices[c_id - 1].text;
            }
          }
        
          const comment = {
            id: q.id,
            questionText: q.questionText,
            questionImage: q.questionImage,
            answer: answer,
            commentText: q.commentText,
            commentImage: q.commentImage
          }

          comments.push(comment);
        }
      }

      this.comments = comments;
      
      // 合格不合格判定
      if (this.numNG > 0) {
        // 不合格
        this.isPassing = false;

      } else {
        // 合格
        this.isPassing = true;

        const test_type = this.testType;
        const test_id = this.testId;

        // 合格済データを入れる
        this.$store.dispatch('PassedTest/addItem', {test_type, test_id});
      }

    },

    computed: {

      questionNum() {
        return this.questions.length;
      }
    },

    methods: {

      gotoPresent() {
        this.$emit('goto-present');
      },
      
      gotoSelfMenu() {
        this.$emit('goto-self-menu');
      },

      gotoFactory() {
        this.$emit('goto-factory');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Study/Parts/Result.vue